import * as COLORS from '@/app/theme/colors/heya'
import '@/src/types/theme' // Import theme type extensions
import { PaletteOptions, ThemeOptions } from '@mui/material/styles'
import flyinTheme from './flyin'

// Heya (heya.flyin.com) is a Flyin sub-brand: same typography, shape, components and
// breakpoints — only the brand-owned palette groups are overridden. Deriving instead of
// copying keeps Heya in step with future Flyin theme changes.
const flyinPalette = flyinTheme.palette as PaletteOptions

const heyaTheme: ThemeOptions = {
    ...flyinTheme,
    palette: {
        ...flyinPalette,
        primary: {
            main: COLORS.BRAND_PRIMARY,
            dark: COLORS.BRAND_PRIMARY_DARK,
            light: COLORS.BRAND_PRIMARY_LIGHT,
            '100': COLORS.BRAND_PRIMARY_100,
            'A100': COLORS.BRAND_PRIMARY_ALPHA_1
        },
        secondary: {
            main: COLORS.BRAND_SECONDARY,
            dark: COLORS.BRAND_SECONDARY_DARK,
            light: COLORS.BRAND_SECONDARY_LIGHT
        },
        link: {
            main: COLORS.LINK_MAIN
        },
        signInPromoBanner: {
            background: COLORS.SIGN_IN_PROMO_BANNER_BG,
            pillBg: COLORS.SIGN_IN_PROMO_BANNER_PILL_BG,
            pillBorder: COLORS.SIGN_IN_PROMO_BANNER_PILL_BORDER,
            ctaBg: COLORS.SIGN_IN_PROMO_BANNER_CTA_BG,
            ctaHoverBg: COLORS.SIGN_IN_PROMO_BANNER_CTA_HOVER_BG
        },
        customThemeButton: {
            primaryBg: COLORS.BRAND_PRIMARY,
            primaryText: COLORS.WHITE,
            primaryHoverBg: COLORS.BRAND_PRIMARY_DARK,
            secondaryBg: COLORS.BRAND_SECONDARY,
            secondaryText: COLORS.BLACK,
            secondaryHoverBg: COLORS.BRAND_SECONDARY_DARK,
            disabledBg: COLORS.NEUTRAL_100,
            disabledText: COLORS.TEXT_DISABLED
        }
    }
}

export default heyaTheme
